import React, { useState, useEffect, createContext } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { getAnalytics, logEvent } from "firebase/analytics";

// config
import { buildCode, buildNumber } from "./build";

// api services
import { SubscriberService } from "../services/";

const SubscriberContext = createContext({});

const Provider = ({ children }) => {
  const history = useHistory();

  const [userProfilephoto, setUserProfilePhoto] = useState("");
  const [saveUserInfoLoader, setSaveUserInfoLoader] = useState(false);
  const [fullUserInfo, setFullUserInfo] = useState({});
  const [userhandle, setUserHandle] = useState();
  const [profileImageSelected, setProfileImageSelected] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showLoadingIndicator, setShowLoadingIndicator] = useState(false);
  const [isProcessingUsername, setProcessingUsername] = useState(false);
  const [isSuccessUsername, setSuccessUsername] = useState();
  const [isFetchingUserProfile, setFetchingUserProfile] = useState();

  return (
    <SubscriberContext.Provider
      value={{
        uploadProfilePhoto,
        userProfilephoto,
        setUserProfilePhoto,
        userhandle,
        setUsername,
        fetchUserProfile,
        fetchUserInfo,
        saveUserInfoLoader,
        fullUserInfo,
        updateUserData,
        saveUserData,
        profileImageSelected,
        getFullUserInfoFromStorage,
        getUserDetailsFromStorage,
        getPhoneNumberFromStorage,
        showLoadingIndicator,
        isFetchingUserProfile,
        userDetails,
        isProcessingUsername,
        setSuccessUsername,
        isSuccessUsername,
      }}
    >
      {children}
    </SubscriberContext.Provider>
  );

  async function getUserDetailsFromStorage() {
    const userData = localStorage.getItem("userDetails");

    setUserDetails(userData ? JSON.parse(userData) : null);
  }

  async function getPhoneNumberFromStorage() {
    const msisdn = localStorage.getItem("phoneNumber");

    if (msisdn) {
      setPhoneNumber(msisdn);
    }

    return msisdn;
  }

  async function saveUserData({ dob, gender, occupation }) {
    setShowLoadingIndicator(true);
    setSaveUserInfoLoader(true);

    const phonenumber = await getPhoneNumberFromStorage();
    const userDetails = await getFullUserInfoFromStorage();

    try {
      await SubscriberService.saveUserData({
        dob,
        gender,
        occupation,
        phonenumber,
        buildCode,
        buildNumber,
        os: "web",
        firstName: userDetails?.["get:FirstName"][0],
        lastName: userDetails?.["get:LastName"]?.[0],
      });

      setSaveUserInfoLoader(false);

      localStorage.setItem("isLoggedIn", "isLoggedIn");
      setShowLoadingIndicator(false);

      history.push("/home");

      //Google analytic data logging
      //   analytics().logEvent("basic_info_collected", {
      //     dob: dob,
      //     gender: gender,
      //     occupation: occupation,
      //   });

      //   navigation.dispatch(
      //     CommonActions.reset({
      //       index: 1,
      //       routes: [{ name: "ThemeSelectorScreen" }],
      //     })
      //   );
    } catch (e) {
      setSaveUserInfoLoader(false);
      setShowLoadingIndicator(false);
    }
  }

  async function getFullUserInfoFromStorage() {
    try {
      const fullUserInfo = localStorage.getItem("fulluserinfo");

      const parsedFullUserInfo = JSON.parse(fullUserInfo);

      if (parsedFullUserInfo) {
        setFullUserInfo(parsedFullUserInfo);

        if (parsedFullUserInfo?.photoUrlThumbnail) {
          setUserProfilePhoto(parsedFullUserInfo?.photoUrlThumbnail);

          setProfileImageSelected(true);
        }

        return parsedFullUserInfo;
      }
    } catch (e) { }
  }

  async function updateUserData(userData) {
    const { phoneNumber } = userData;

    try {
      const { data, success, code } = await SubscriberService.updateUserData({
        ...userData,
        phonenumber: phoneNumber,
      });

      if (success) {
      }
    } catch (e) { }
  }

  async function fetchUserInfo(msisdn) {
    try {
      setFetchingUserProfile(true);
      const { data, success, code } = await SubscriberService.fetchUserInfo(
        msisdn
      );

      if (success) {
        if (data) {
          setFullUserInfo(data);

          if (data?.photoUrlThumbnail) {
            setUserProfilePhoto(data?.photoUrlThumbnail);
            setProfileImageSelected(true);
          }

          try {
            const strigifiedUserinfo = JSON.stringify(data);

            if (strigifiedUserinfo) {
              localStorage.setItem("fulluserinfo", strigifiedUserinfo);
            }
          } catch (e) { }
        }
      } else if (!success && code === "003") {
        try {
          localStorage.clear();

          //   Alert.alert(
          //     "MTN Pulse",
          //     "Your session has expired! Please login again.",
          //     [{ text: "Exit", onPress: () => RNExitApp.exitApp() }],
          //     {
          //       cancelable: false,
          //     }
          //   );
        } catch (e) { }
      }
    } catch (e) { } finally {
      setFetchingUserProfile(false);
    }
  }

  async function setUsername(username) {
    setProcessingUsername(true);
    const token = JSON.parse(localStorage.getItem("token"));
    try {
      const data = await SubscriberService.setUsername(username, token);
      setUserHandle(username);
      setSuccessUsername(true);
    } catch (e) {
      setSuccessUsername(false);
    } finally {
      setProcessingUsername(false);
    }
  }

  async function fetchUserProfile() {
    const token = JSON.parse(localStorage.getItem("token"));
    try {
      const data = await SubscriberService.fetchUserProfile(token);

      if (data.success) {
        const {
          userProfile: { username, photoUrlThumbnail },
        } = data;
        setUserProfilePhoto(photoUrlThumbnail);
        setUserHandle(username);
        setUserDetails(data?.userProfile)
      }
    } catch (e) { }
  }

  async function uploadProfilePhoto(file) {
    const token = JSON.parse(localStorage.getItem("token"));
    try {
      const formData = new FormData();

      formData.append("photo", file);

      const { userProfile } = await SubscriberService.uploadProfilePhoto(
        formData,
        token
      );

      const { photoUrlThumbnail } = userProfile;

      if (photoUrlThumbnail) {
        setUserProfilePhoto(photoUrlThumbnail);
      }
      return true;
    } catch (e) {
      return false;
    }
  }
};

SubscriberContext.ProviderWrapper = Provider;

Provider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SubscriberContext;
